import { Box, Typography } from '@mui/material';

import { useNavigationUpdate } from 'modules/common/components/Navigator/context';
import { MessageCenterScreen } from 'modules/common/components/Navigator/context/NavigatorContext.interface';
import useTicket from 'services/help-center/queries/useTicket';

export default function ClosedMessage({ ticketId }: { ticketId: number }) {
    const { navigateToPage } = useNavigationUpdate();

    const { data } = useTicket(ticketId);

    const ticket = data?.ticket;

    if (ticket?.status !== 'closed') {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: 3,
            }}>
            <Typography variant="caption" sx={{ color: 'cement.500' }}>
                This message has been closed. Still need help?
            </Typography>
            <Typography
                variant="caption"
                onClick={() => navigateToPage(MessageCenterScreen.NEW_MESSAGE)}
                sx={{ textDecoration: 'underline', color: 'cement.500', cursor: 'pointer' }}>
                Send us a new message
            </Typography>
        </Box>
    );
}
